import styled from "styled-components";

const Title = styled.h1` 
margin-top: 16vh;
width: 100%;
text-align:center;
text-transform: uppercase;
`

export default Title;